import { createSlice } from '@reduxjs/toolkit';

type ReasonWithScenarioIDs = {
  scenarioIds: Array<number>;
  name: string;
};

export interface ScenariosState {
  reasons: string[];
  reasonsWithScenarioIDs: ReasonWithScenarioIDs[];
}

const initialState: ScenariosState = {
  reasons: [],
  reasonsWithScenarioIDs: [],
};

const scenariosSlice = createSlice({
  name: 'scenarios',
  initialState,
  reducers: {
    fetchReasonsSuccess: (state, action) => {
      state.reasons = action.payload;
      state.reasonsWithScenarioIDs = [];
    },
    fetchReasonsV2Success: (state, action) => {
      state.reasons = [];
      state.reasonsWithScenarioIDs = action.payload;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = scenariosSlice;
// Extract and export each action creator by name
export const { fetchReasonsSuccess, fetchReasonsV2Success } = actions;
// Export the reducer, either as a default or named export
export default reducer;
